export default "__VITE_ASSET__f5qasXVj__"